var module = angular.module('octopusApp.infrastructure');

module.filter('ellipsis', function () {
  return function (input, format) {
    var count = parseInt(format || "30", 10);
    return input.length > count ? input.slice(0, count - 2) + '…' : input;
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/ellipsis.js
// module id = 1135030829017866
// module chunks = 1